<div class="w-100 border-top border-dashed pt-4">
  <p class="font-13">
    <strong>{{ 'attendance.tag.tags' | translate }}</strong>
  </p>
  <mat-select
    class="form-control"
    (selectionChange)="selected($event)"
    [placeholder]="'attendance.tag.selectTagPlaceholder' | translate"
  >
    @for (item of tags; track $index) {
    <mat-option [value]="item">{{ item.title }}</mat-option>
    }
  </mat-select>

  <div class="d-flex gap-2 pt-2 flex-wrap tags-content">
    @for (item of getFilteredList(); track item) {
    <!-- bgColor is optional: without a fallback class the badge renders white-on-white,
         hiding both the title and the delete icon. -->
    <span
      class="badge font-14 d-flex align-items-center gap-1"
      [class.bg-secondary]="!item.bgColor"
      [ngStyle]="{ 'background-color': item.bgColor || null, color: (item.bgColor | readableText) }"
    >
      {{ item.title }}
      <i
        class="ri-delete-bin-5-line text-light"
        (click)="remove(item)"
        style="cursor: pointer"
      ></i>
    </span>
    }
  </div>
</div>
